(function(headerContainer, adminRegion){

  window.addEventListener('load', function(){
  let latestKnownScrollY = 0,
      ticking = false,
      distanceFromTop = 0;

  const cookiePopup = document.getElementById('sliding-popup')


  if (adminRegion) {
    distanceFromTop += adminRegion.clientHeight - 12;
  }

  if (cookiePopup) {
    distanceFromTop += cookiePopup.clientHeight

  }

  function updateHeader(element, scrollY) {
    scrollY = scrollY || window.pageYOffset
    let scrollAnchor = (element.clientHeight) + distanceFromTop
    if (scrollY > scrollAnchor) {
      element.classList.add('active')
    } else {
      element.classList.remove('active')
    }
  }

  // Wait for this event to be fired so that we know rendering is done
  // which results in more reliable calculations
    // All of these functions would ideally be put in their own class
    // so we can reuse them across multiple components
    function update() {
      ticking = false
      let currentScrollY = latestKnownScrollY
      updateHeader(headerContainer, currentScrollY)
    }

    function onScroll() {
      latestKnownScrollY = window.scrollY
      requestTick()
    }

    function requestTick() {
      if(!ticking) {
        requestAnimationFrame(update)
      }
      ticking = true
    }

    updateHeader(headerContainer)

    document.addEventListener('scroll', function(){
      onScroll()
    }, {passive: true})
  })
})(headerContainer, adminRegion);
